//import {Navigate} from "react-router-dom";
import {useParams, Navigate} from "react-router";

export const Redirect = () => {

    const { where, param, id } = useParams()

    switch (where) {
        case 'dashboard':
            return <Navigate to={`/dashboard/${param}`}/>
        case 'upload':
            return <Navigate to={`/upload/${param}`}/>
        case 'workflow':
            return <Navigate to={`/workflow/${param}/${id}`}/>
        case 'content':
            return <Navigate to={`/content`}/>
        case 'tags':
            return <Navigate to={`/tags`}/>
    }

/*    return <Navigate to={param} />

    switch (param) {
        case 'home':
            return <Navigate to={`/dashboard/${param}`}/>
        case 'workflow':
            return <Navigate to={`/workflow/${id > 0 ? id : ''}`}/>
        case 'users':
        if( id === '0') {
            return <Navigate to={`/users`} />
        } else {
            return <Navigate to={`/users/edit/${id}`}/>
        }
        default:
            return <Navigate to={`/dashboard/${param}`}/>
    }*/
}
